// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/activity_schedule.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_type_date } from "@buf/googleapis_googleapis.bufbuild_es/google/type/date_pb.js";
import { file_google_type_dayofweek } from "@buf/googleapis_googleapis.bufbuild_es/google/type/dayofweek_pb.js";
import { file_studyo_today_schedules_v1_resources_activity } from "./activity_pb.js";
import { file_studyo_today_schedules_v1_resources_period } from "./period_pb.js";

/**
 * Describes the file studyo/today/schedules/v1/resources/activity_schedule.proto.
 */
export const file_studyo_today_schedules_v1_resources_activity_schedule = /*@__PURE__*/
  fileDesc("CjtzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9hY3Rpdml0eV9zY2hlZHVsZS5wcm90bxIjc3R1ZHlvLnRvZGF5LnNjaGVkdWxlcy52MS5yZXNvdXJjZXMijQMKEEFjdGl2aXR5U2NoZWR1bGUSCgoCaWQYASABKAkSPwoIYWN0aXZpdHkYAiABKAsyLS5zdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcy5BY3Rpdml0eRITCgljeWNsZV9kYXkYAyABKAVIABItCgtkYXlfb2Zfd2VlaxgEIAEoDjIWLmdvb2dsZS50eXBlLkRheU9mV2Vla0gAEiAKA2RheRgFIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVIABIWCgxwZXJpb2RfbGFiZWwYBiABKAlIARI9CgZwZXJpb2QYByABKAsyKy5zdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcy5QZXJpb2RIARIPCgd0ZXJtX2lkGAggASgJEhQKDHNjaGVkdWxlX3RhZxgJIAEoCRIRCglyb29tX25hbWUYCiABKAkSEAoIcmV2aXNpb24YCyABKAUSFQoNc2hvdWxkX2RlbGV0ZRgMIAEoCEIGCgR3aGVuQgQKAmF0QiuqAihTdHVkeW8uVG9kYXkuU2NoZWR1bGVzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_google_type_date, file_google_type_dayofweek, file_studyo_today_schedules_v1_resources_activity, file_studyo_today_schedules_v1_resources_period]);

/**
 * Describes the message studyo.today.schedules.v1.resources.ActivitySchedule.
 * Use `create(ActivityScheduleSchema)` to create a new message.
 */
export const ActivityScheduleSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_activity_schedule, 0);

